import AbstractModel from "./abstract";

import BusinessAddress from "./business/address";


export default class Business extends AbstractModel{
    constructor(){
        super();

        this.name = "";
        this.addess = "";
        this.address2 = "";
        this.zip_code = "";
        this.city = "";
        this.country = "";
        this.siren = "";
        this.activity = "";
        this.logo_data = null;
        this.batch_invoicing = false;

        this.new_logo = null;
    }

    load(id, onLoaded=null, onError=null){
        this.api.get("/business/" + id)
            .then(results => { 
                this.id = results.business.id || null;
                this.name = results.business.name || "";
                this.siren = results.business.siren || "";
                this.address = results.business.address || "";
                this.address2 = results.business.address2 || "";
                this.zip_code = results.business.zip_code || "";
                this.city = results.business.city || "";
                this.country = results.business.country || "";
                this.activity = results.business.type_activity || "";
                this.logo_data = results.business.logo_data || "";
                this.batch_invoicing = results.business.batch_invoicing || false;
                if(onLoaded)
                    onLoaded();
             })
            .catch(onError);
    }

    save(onSaved=null, onError=null){
        if(!this.id)
            return false;

        let data = {
            name: this.name,
            address: this.address,
            address2: this.address2,
            zip_code: this.zip_code,
            city: this.city,
            country: this.country,
            siren: this.siren,
            type_activity: this.activity
        };

        if(this.new_logo){
            data['logo'] = this.new_logo;
            this.new_logo = null;
        }

        this.api.put("/business/" + this.id, data)
            .then(() => {
                if(onSaved)
                    onSaved();
            })
            .catch((error) => {
                if(onError)
                    onError(error);
            });
    }

    static getAddresses(onLoaded=null, onError=null){
        if(onLoaded){
            AbstractModel.getApi().get("/business/addresses")
                .then(results => {
                    let addresses = [];
                    for(let data of results.addresses){
                        addresses.push(new BusinessAddress({
                            location: data.address,
                            name: data.name,
                            id: data.id
                        }));
                    }
                    onLoaded(addresses);
                })
                .catch(onError);
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/business.js